import _ from "lodash";
import { Autocomplete, CircularProgress, IconButton, TextField } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import InputBox from "../input/InputBox";
import { PField } from "../input/NestedField";
import { fetchArray } from "entity";
import EntitySearchDialog from "./EntitySearchDialog";
import { fieldHasError, requiredValidator } from "../input/validator";
import { flog } from "util/FileLogger";

export default function EntitySearchInput({
    name,
    label,
    required,
    helperText,
    EntityClass,
    initialValue,
    optionLabelField,
    extraQuery,
    sortResult,
    onChange,
    fieldFilterAdd,
    loadOnRender,
    autoSelectOne,
    sx,
    InputLabelProps,
    ...props
}) {
    const [options, setOptions] = useState([]);
    const [open, setOpen] = useState(false);
    const loading = open && options.length === 0;

    const [searchDialog, setSearchDialog] = useState();

    const labelField = optionLabelField ?? EntityClass.labelField;

    const loadOptions = useCallback(async () => {
        // Carrega apenas uma vez.
        // if (options.length === 0) {
        // console.log('loadOptions start')
        // const result = await fetchArray(EntityClass.getAll());
        let query = await EntityClass.query();

        // console.log('loadOptions return')
        if (extraQuery) {
            query = extraQuery(query);
        }

        const result = await fetchArray(query.get());
        if (sortResult) {
            result.sort(sortResult)
        }

        setOptions(["", ...result]);
        // }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [EntityClass, extraQuery]);

    useEffect(() => {
        // Carrega ao abrir auto complete.
        if (open || loadOnRender) {
            loadOptions();
        }
        return () => {

        }
    }, [loadOptions, open, loadOnRender]);

    function openSearchDialog() {
        loadOptions();
        searchDialog.setOpen(true);
    }
    function getOptionLabel(option) {
        let v = _.get(option, labelField);
        if (fieldFilterAdd || option) {
            let addV = _.get(option, fieldFilterAdd);
            if (addV) {
                v += " - " + addV
            }
        }
        return v || ''

    }

    return (
        <InputBox sx={sx}>
            <PField
                name={name}
                initialValue={initialValue}
                validate={required ? requiredValidator : null}
                onChange={onChange}
            >
                {(fieldProps) => {
                    const hasError = fieldHasError(fieldProps.meta);
                    if (autoSelectOne && options.length === 2 && !fieldProps.input.value) {

                        fieldProps.input.onChange(options[1])
                    }
                    let optionsUse = [...options] || []

                    if (!fieldProps.input.value) {
                        optionsUse.push("")
                    }
                    return (
                        <>
                            <Autocomplete
                                options={optionsUse}
                                getOptionLabel={getOptionLabel}
                                isOptionEqualToValue={(option, value) => option.uid === value.uid}
                                //
                                renderOption={(props, option) =>
                                    option.uid && option[labelField] ? (
                                        <li {...props} key={option.uid}>
                                            {getOptionLabel(option)}
                                        </li>
                                    ) : null
                                }
                                //
                                open={open}
                                onOpen={() => setOpen(true)}
                                onClose={() => setOpen(false)}
                                loading={loading}
                                //
                                sx={sx || { flex: 1 }}
                                forcePopupIcon={false}
                                renderInput={(params) => (
                                    <TextField
                                        label={label}
                                        required={required}
                                        error={hasError}
                                        helperText={hasError ? fieldProps.meta.error : helperText}
                                        variant="standard"
                                        {...params}
                                        InputLabelProps={InputLabelProps}
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <>
                                                    {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                                    <IconButton onClick={openSearchDialog} sx={{ p: "2px" }}>
                                                        <SearchIcon />
                                                    </IconButton>
                                                    {params.InputProps.endAdornment}
                                                </>
                                            ),
                                        }}
                                    />
                                )}
                                //
                                {...fieldProps.input}
                                {...props}
                                onChange={(event, value) => {
                                    flog("Selector " + EntityClass.collectionUID + " - SelectItemChange -" + (value ? value.uid : "null"));
                                    // Necessário para passar os valores do MUI para o Final Form imediatamente.
                                    fieldProps.input.onChange(value);
                                }}
                            />

                            <EntitySearchDialog
                                title={label}
                                columns={EntityClass.searchColumns}
                                data={options}
                                setDialog={setSearchDialog}
                                onClose={(value) => {
                                    flog("Selector " + EntityClass.collectionUID + " - SelectItemDialog -" + value.uid);
                                    fieldProps.input.onChange(value);
                                }}
                            />
                        </>
                    );
                }}
            </PField>
        </InputBox>
    );
}
